import { createSlice } from "@reduxjs/toolkit";

// 🚀 GLOBAL NOTIFICATION VIEWED STATE: Now stored server-side (persists across all devices/wallets)
const initialState = {
  items: [],
  eventToEmit: null,
  lastViewedAt: null, // Timestamp when notifications were last viewed (stored in database)
};

export const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addItem: (state, action) => {
      if (action.payload.type === "event") {
        let newArray = [];
        for (let i = 0; i < state.items.length; i++) {
          if (
            state.items[i].data?.token_id === action.payload.data?.token_id &&
            state.items[i].data?.sender === action.payload.data?.sender
          ) {
          } else {
            newArray.push(state.items[i]);
          }
        }
        state.items = newArray;
      }
      if (action.payload.type === "message") {
        let newArray = [];
        for (let i = 0; i < state.items.length; i++) {
          if (state.items[i].data?.id !== action.payload.data?.id) {
            newArray.push(state.items[i]);
          }
        }
        state.items = newArray;
      }
      state.items.push(action.payload);
    },
    removeItem: (state, action) => {
      state.items.splice(action.payload, 1);
    },
    removeNotificationById: (state, action) => {
      // Remove notification by unique identifier
      // For events: match by token_id, sender, and action (or txHash if available)
      // For messages: match by chat id
      const { type, identifier } = action.payload;
      
      if (type === "event") {
        const { token_id, sender, action: eventAction, txHash } = identifier;
        state.items = state.items.filter((item) => {
          if (item.type !== "event") return true;
          // Match by txHash if available (most specific)
          if (txHash && item.data.txHash === txHash) return false;
          // Otherwise match by token_id, sender, and action
          if (
            item.data.token_id === token_id &&
            item.data.sender === sender &&
            item.data.action === eventAction
          ) {
            return false;
          }
          return true;
        });
      } else if (type === "message") {
        const { chatId } = identifier;
        state.items = state.items.filter((item) => {
          if (item.type !== "message") return true;
          return item.data.id !== chatId;
        });
      }
    },
    removeTxByHash: (state, action) => {
      for (let i = 0; i < state.items.length; i++) {
        if (
          state.items[i].type === "event" &&
          state.items[i].data.txHash === action.payload
        )
          state.items.splice(i, 1);
      }
    },
    setEventToEmit: (state, action) => {
      state.eventToEmit = action.payload;
    },
    setLastViewedAt: (state, action) => {
      // Set lastViewedAt from server (called after API fetch)
      state.lastViewedAt = action.payload;
    },
  },
});

export const { addItem, removeItem, removeNotificationById, setEventToEmit, removeTxByHash, setLastViewedAt } =
  NotificationSlice.actions;

export default NotificationSlice.reducer;
